import { Immutable } from "immer";
import React from "react";

import type { OfferSectionBlock as Value } from "@reactivated";

import { OfferCardBlock } from "../OfferCardBlock";

type Props = Immutable<{
    value: Value;
}>;

/**
 * React port of the pillows-specific ``OfferSectionBlock`` (defined in
 * ``server/cms/pages/product_filter_grid.py``). Wraps the legacy
 * ``.pillow-filter-page-offers`` markup that used to live inline in the
 * ProductFilterGridPage Django template (lines ~115-126 of
 * ``product_filter_grid_page.html`` before the F5 cutover). Each child
 * ``OfferCardBlock`` receives its 1-indexed position via ``cardNum`` so
 * the learn-more CTA preserves the original ``?pid=learnmoreN_…``
 * tracking suffix.
 */
export const OfferSectionBlock = (props: Props): React.JSX.Element => {
    const v = props.value;
    const cards = v.offer_cards ?? [];
    return (
        <div className="pillow-filter-page-offers l-capped-width">
            <div className="pillow-filter-page-offers__title">{v.heading}</div>
            <div className="pillow-filter-page-offers__cards offer-list u-flex-container">
                {cards.map((card, i) => (
                    <OfferCardBlock
                        key={i}
                        value={card}
                        cardNum={i + 1}
                        refPage="shopallpillows"
                    />
                ))}
            </div>
        </div>
    );
};
